import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Meta from "../components/Meta";
import Container from "../components/Container";
import { base_url } from "../utils/axiosConfig";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${base_url}user/verify-email/${token}`);
        if (response.data.success) {
          setMessage("Email verified successfully! You can now log in to your account.");
        } else {
          setError(true);
          setMessage(response.data.message || "Email verification failed.");
        }
      } catch (err) {
        setError(true);
        setMessage(err.response?.data?.message || "Email verification failed.");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setError(true);
      setMessage("Invalid verification link.");
      setLoading(false);
    }
  }, [token]);

  return (
    <>
      <Meta title={"Verify Email"} />
      <Container class1="login-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="auth-card">
              <h3 className="text-center mb-3">Email Verification</h3>
              <div className="text-center">
                {loading ? (
                  <div className="d-flex justify-content-center my-4">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className={error ? "text-danger" : "text-success"}>{message}</p>
                    {!error && (
                      <>
                        <button 
                          className="button border-0 mb-3" 
                          onClick={() => navigate("/login")}
                        >
                          Go to Login
                        </button>
                        <p className="text-gray-600 mt-3">
                          If you need to resend the verification email, visit the{' '}
                          <Link to="/resend-verification" className="text-red-500 hover:text-red-600 font-semibold">
                            Resend Verification
                          </Link>{' '}
                          page.
                        </p>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default VerifyEmail;